module.exports = __webpack_public_path__ + "img/4.6da08047.jpg";